module.exports = "\n<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// /media/krylancelo/OS/Data/Work/krylab/Artetia/beta/src/app/app.component.html
// module id = ../../../../../../../../../../../media/krylancelo/OS/Data/Work/krylab/Artetia/beta/src/app/app.component.html
// module chunks = main